import { colors } from '@alixpartners/ui-components';
import styled, { css } from 'styled-components';
import { black, grey500 } from 'styles/colors';

const enableScroll = css`
	overflow-y: scroll;
	height: 400px;
`;

const disableScroll = css`
	overflow-y: unset;
	height: auto;
	width: auto;
`;

export const Wrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
`;

export const Main = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: auto;
`;

export const ChartWrapper2 = styled.div`
	padding: 0 32px;
	display: flex;
	flex-direction: column;
	width: auto;
`;

export const ProcurementChartWrapper = styled.div`
	padding-bottom: 5px;
`;

export const ChartWrapper = styled.div`
	padding: 0 32px;
	display: flex;
	flex-direction: column;
	width: auto;
`;

export const Title = styled.div`
	font-style: normal;
	font-weight: 500;
	font-size: 23px;
	line-height: 31px;
	letter-spacing: 0.3px;
	color: ${colors.grey7};
	display: flex;
	padding: 16px 0 0 0;
`;

export const LoaderWrapper = styled.div`
	verticalalign: middle;
	minheight: 60rem;
	borderbottom: 1px solid #d4d4d4;
	margintop: 9rem;
	width: 100%;
`;

export const AnalysisWrapper2 = styled.div`
	margin: ${props => (props.index === '0' ? '1% 0 2%' : '0 0 1%')};
	border: 1px solid #878787;
	background-color: #e6e6e6;
	${props =>
		props.isScroll && props.isExpanded ? enableScroll : disableScroll};
`;

export const ReferenceContainer = styled.div`
	width: 100%;
	text-align: center;
	margin-top: 1rem;
	font-weight: bold;
`;

export const GreenBox = styled.div`
	height: 15px;
	width: 15px;
	background-color: #5cb335;
	display: inline-block;
	position: relative;
	top: 2px;
	margin-left: 5px;
	margin-right: 5px;
`;

export const AnalysisWrapper = styled.div`
	margin: ${props => (props.index === '0' ? '1% 0 2%' : '0 0 1%')};
	border: 1px solid #878787;
	background-color: #e6e6e6;
	position: relative;
	${props =>
		props.isScroll && props.isExpanded ? enableScroll : disableScroll};
`;
// overflow-y: ${props => (props.isExpanded ? 'scroll' : 'unset')};
// height: ${props => (props.isExpanded ? '400px' : '111px')};

export const TableContainer = styled.table`
	width: 100%;
`;

export const TableHead = styled.thead`
	text-align: left;
	position: sticky;
	top: 0;
	z-index: 1;
	height: auto;
	min-height: 50px;
	background: #ffffff;
	box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
`;

export const TableRow = styled.tr``;

export const TableCellGroup = styled.th`
	padding: 12px 8px;
	white-space: nowrap;
`;

export const TableCellPeerCount = styled.th`
	width: 8%;
	padding: 14px 5px;
	text-align: center;
`;

export const TableCellMin = styled.th`
	width: 8%;
	padding: 14px 5px;
	text-align: center;
`;

export const TableCellChart = styled.th`
	width: 42%;
	padding: 0 30px;
`;

export const TableCellMax = styled.th`
	width: 8%;
	padding: 14px 5px;
	text-align: center;
`;

export const TableBody = styled.tbody`
	background-color: ${colors.grey200};
`;

export const DateRangeWrapper = styled.div`
	.ap-month-picker > div:nth-child(2) {
		top: 0;
		right: 50%;
	}
`;
export const MetadataSummaryLine = styled.tr`
	vertical-align: middle;
`;

export const SummaryLabel = styled.td`
	color: ${grey500};
	font-size: 16px;
	line-height: 32px;
	font-weight: normal;
	padding: 12px 64px 12px 12px;
`;

export const SummaryValue = styled.td`
	color: ${black};
	font-size: 16px;
	font-weight: 500;
	line-height: 32px;
	display: flex;
	align-items: flex-start;
	padding: 8px 0;
	height: 56px;
`;
